import { MarkerClustererF, MarkerF } from "@react-google-maps/api";

const PoleClusterLayer = ({
    visible,
    data,
    box,
    options,
    onMarkerClick,
}) => {
    if (!visible) return null;

    return (
        <MarkerClustererF
            options={options}
        >
            {(clusterer) =>
                box &&
                data.map(item => (
                    <MarkerF
                        clusterer={clusterer}
                        key={item.info.GlobalID}
                        position={item.coords}
                        icon={item.iconSymbol}
                        options={{ optimized: true }}
                        onClick={(e) => onMarkerClick(item, e)}
                    />
                ))
            }
        </MarkerClustererF>
    );
};

export default PoleClusterLayer;